import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp16};
`

export const Description = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: ${props => props.theme.spacing.sp16};
`
